/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Cancel_Reason_Found_AlternativeInputs */

const en_settings_cancel_reason_found_alternative = /** @type {(inputs: Settings_Cancel_Reason_Found_AlternativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Found an alternative`)
};

const id_settings_cancel_reason_found_alternative = /** @type {(inputs: Settings_Cancel_Reason_Found_AlternativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemu alternatif lain`)
};

/**
* | output |
* | --- |
* | "Found an alternative" |
*
* @param {Settings_Cancel_Reason_Found_AlternativeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_cancel_reason_found_alternative = /** @type {((inputs?: Settings_Cancel_Reason_Found_AlternativeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Cancel_Reason_Found_AlternativeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_cancel_reason_found_alternative(inputs)
	return en_settings_cancel_reason_found_alternative(inputs)
});